module.exports = __webpack_public_path__ + "static/media/dong_song_text_03.7d6b3bf1.jpg";